import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-client-panel',
    templateUrl: './client-panel.component.html',
    standalone: false
})
export class ClientPanelComponent implements OnInit {
  ngOnInit(): void {
  
  }
}